export default __webpack_public_path__ + "src/images/galleries/2/entry-a37c78.png";